import { type, mergeWith, isNil } from 'ramda';
import { EActiveView } from '../types/view';
import { getRememberedAccounts } from '../utils/rememberedAccounts';
export function deepMerge(value1, value2) {
  if (type(value1) === 'Object' && type(value2) === 'Object') {
    return mergeWith(deepMerge, value1, value2);
  } else if (isNil(value2)) {
    return value1;
  } else {
    return value2;
  }
}
export function getPreparedPreloadedState(config) {
  var isBrowserBuild = process.env.IS_BROWSER_BUILD;
  var rememberAccountsFlow = config.get('auth.rememberAccountsFlow.enabled');
  var accounts = isBrowserBuild === 'true' ? getRememberedAccounts() : [];
  var isRememberAccountsFlow = accounts.length !== 0 && rememberAccountsFlow || false;
  var initialView = isRememberAccountsFlow ? EActiveView.RememberedAccountsSelect : EActiveView.PhoneAuth;
  var preparedPreloadedState = {
    view: {
      active: initialView
    },
    autoFocusDisabled: false,
    isRememberAccountsFlow: isRememberAccountsFlow
  };
  return preparedPreloadedState;
}